/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupslinkcopied2Inputs */

const en_groupslinkcopied2 = /** @type {(inputs: Groupslinkcopied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

const de_groupslinkcopied2 = /** @type {(inputs: Groupslinkcopied2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopiert`)
};

/**
* | output |
* | --- |
* | "Link copied" |
*
* @param {Groupslinkcopied2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupslinkcopied2 = /** @type {((inputs?: Groupslinkcopied2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupslinkcopied2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupslinkcopied2(inputs)
	return de_groupslinkcopied2(inputs)
});
export { groupslinkcopied2 as "groupsLinkCopied" }